import { render, staticRenderFns } from "./SelectPlaceMessage.vue?vue&type=template&id=747ed61e"
import script from "./SelectPlaceMessage.vue?vue&type=script&lang=js"
export * from "./SelectPlaceMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports